import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Account, BffGetListAccountsEndpoint, BffGetOneAccountEndpoint } from 'lingo2-api-models';
import type { IPagination } from 'lingo2-models';
import { map, type Observable } from 'rxjs';

export type AccountDetails = BffGetOneAccountEndpoint.Body['details'];

@Injectable({ providedIn: 'root' })
export class AccountsBffService {
  private readonly http = inject(HttpClient);
  private baseUrl = (path: string): string => `${environment.bff_url}/${path}`;

  getOne(dto: BffGetOneAccountEndpoint.Body): Observable<Account> {
    return this.http
      .post<BffGetOneAccountEndpoint.Response>(this.baseUrl(BffGetOneAccountEndpoint.path), dto, { observe: 'body' })
      .pipe(
        map((response) => {
          if (response.status === 'ok') {
            return response.data.item;
          } else {
            console.error(response.errorMessage);
            return null;
          }
        }),
      );
  }

  getList(dto: BffGetListAccountsEndpoint.Body): Observable<{ list: Account[]; pagination: IPagination }> {
    return this.http
      .post<BffGetListAccountsEndpoint.Response>(this.baseUrl(BffGetListAccountsEndpoint.path), dto, {
        observe: 'body',
      })
      .pipe(
        map((response) => {
          if (response.status === 'ok') {
            return response.data;
          } else {
            console.error(response.errorMessage);
            return { list: [], pagination: null };
          }
        }),
      );
  }
}
